export const FETCH_AFFILIATE_DASHBOARD = {
  START: "FETCH_AFFILIATE_DASHBOARD_START",
  SUCCESS: "FETCH_AFFILIATE_DASHBOARD_SUCCESS",
  ERROR: "FETCH_AFFILIATE_DASHBOARD_ERROR",
};

export const FETCH_AFFILIATE_DASHBOARD_SIX_MONTH = {
  START: "FETCH_AFFILIATE_DASHBOARD_SIX_MONTH_START",
  SUCCESS: "FETCH_AFFILIATE_DASHBOARD_SIX_MONTH_SUCCESS",
  ERROR: "FETCH_AFFILIATE_DASHBOARD_SIX_MONTH_ERROR",
};

export const FETCH_AFFILIATE_DASHBOARD_DATA = {
  START: "FETCH_AFFILIATE_DASHBOARD_DATA_START",
  SUCCESS: "FETCH_AFFILIATE_DASHBOARD_DATA_SUCCESS",
  ERROR: "FETCH_AFFILIATE_DASHBOARD_DATA_ERROR",
};

export const FETCH_AFFILIATE_RESERVATIONS = {
  START: "FETCH_AFFILIATE_RESERVATIONS_START",
  SUCCESS: "FETCH_AFFILIATE_RESERVATIONS_SUCCESS",
  ERROR: "FETCH_AFFILIATE_RESERVATIONS_ERROR",
};

export const FETCH_AFFILIATE_DASHBOARD_INIT = "FETCH_AFFILIATE_DASHBOARD_INIT";

export const TOAST = {
  RESET: "RESET_AFFILIATE_DASHBOARD_TOAST",
};
